import { BASE_ELEMENT_IDS } from "./BaseDOM";
import { STATES } from "../states/states";
import { ACTION_EVENTS } from "./UserAction";
import events from "../events/EventsObservable";
import Wallet from "../wallet/Wallet";
import IUIActions from "./IUIActions";
import IStatesManager from "../states/IStatesManager";
import IAudio from "../engine/IAudio";

export default class KeydownHandler {
	wallet: Wallet;
	actions: IUIActions;
	statesManager: IStatesManager;
	audio: IAudio;
	keyBindings: Map<string, string> = new Map<string, string>()

	constructor(
		wallet: Wallet,
		actions: IUIActions,
		statesManager: IStatesManager,
		audio: IAudio
	) {
		this.wallet = wallet;
		this.actions = actions;
		this.statesManager = statesManager;
		this.audio = audio;
	}

    init() {
       window.addEventListener("keydown", event => this.keydown({event}));
    }

	initFromConfig(bindings: [any]) {
		window.addEventListener("keydown", event => this.keydownBindingsEvent({event}));
		this.keyBindings.set("ArrowUp", "ArrowUp")
        this.keyBindings.set("+", "+")
        this.keyBindings.set("ArrowDown", "ArrowDown")
        this.keyBindings.set("-", "-")
        this.keyBindings.set("m", "m")
        this.keyBindings.set("PageUp", "PageUp")
        this.keyBindings.set("p", "p")
        this.keyBindings.set("PageDown", "PageDown")
        this.keyBindings.set("o", "o")
        this.keyBindings.set("f", "f")
        this.keyBindings.set("Backspace", "Backspace")
		if(bindings)
			bindings.forEach((value) => this.keyBindings.set(value.key,value.command))
	}

	keydownBindingsEvent({event}) {
        if(!event.key) return;
        let key = event.key === " " ? "space" : (event.key === "Enter" ? "enter" : event.key)
        if(!this.keyBindings.has(key)) return;

        switch (this.keyBindings.get(key)) {
            case "spin":
                this.preventDefault(event);
                this.keydownEnter();
                break;

            case "info":
				this.keydownI();
				break;

			case "m":
				this.keydownM();
				break;

			case "ArrowUp":
			case "+":
				this.keydownArrowUp();
				break;

			case "ArrowDown":
			case "-":
				this.keydownArrowDown();
				break;

			case "PageUp":
			case "p":
				this.keydownPageUp();
				break;

			case "PageDown":
			case "o":
				this.keydownPageDown();
				break;

			case "f":
				this.keydownF();
				break;
			case "Backspace":
				this.keydownBackspace(event);
				break;
		}		
	}

	keydown({ event }) {
		this.focusSpinBtn();

        if(!event.key) return;

        switch (event.key) {
            case " ":
            case "Enter":
                this.preventDefault(event);
                this.keydownEnter();
                break;

            case "i":
				this.keydownI();
				break;

			case "m":
				this.keydownM();
				break;

			case "ArrowUp":
			case "+":
				this.keydownArrowUp();
				break;

			case "ArrowDown":
			case "-":
				this.keydownArrowDown();
				break;

			case "PageUp":
			case "p":
				this.keydownPageUp();
				break;

			case "PageDown":
			case "o":
				this.keydownPageDown();
				break;

			case "f":
				this.keydownF();
				break;
			case "Backspace":
				this.keydownBackspace(event);
				break;
		}
	}

	keydownEnter() {
		let state = this.statesManager.getState();

		switch (state) {
			case STATES.PREINFO:
				if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_PREINFO_CLOSE))
					return;
				events.dispatch(ACTION_EVENTS.ACTION_PREINFO_CLOSE);
				break;

			case STATES.SKIP:
				if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_SKIP)) return;
				events.dispatch(ACTION_EVENTS.ACTION_SKIP);
				break;

			case STATES.SPIN:
				if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_FORCESTOP))
					return;
				events.dispatch(ACTION_EVENTS.ACTION_FORCESTOP);
				break;

			case STATES.FORCESPIN:
				if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_SPIN)) return;
				events.dispatch(ACTION_EVENTS.ACTION_SPIN);
				break;

			case STATES.BONUS_WHEEL:
				if (
					!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_BONUS_WHEEL_STOP)
				)
					return;
				events.dispatch(ACTION_EVENTS.ACTION_BONUS_WHEEL_STOP);
				break;

			case STATES.SEARCHING:
				if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_FORCESTOP))
					return;
				events.dispatch(ACTION_EVENTS.ACTION_FORCESTOP);
				break;

			default:
				this.pressButton();
				break;
		}
	}

	focusSpinBtn() {
		let spinBtn = $(`#${BASE_ELEMENT_IDS.BUTTON_SPIN}`);
		spinBtn.focus();
	}

	pressButton() {
		let element = document.getElementById(BASE_ELEMENT_IDS.BUTTON_SPIN);

		let action = $(element).data("action");
		let data = $(element).data("data");

		if (!this.actions.isActionAllowed(action)) return;
		events.dispatch(action, data);

		element.classList.add("active");
		setTimeout(() => {
			element.classList.remove("active");
		}, 200);
	}

	keydownI() {
		if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_INFO_TOGGLE)) return;

		let state = this.statesManager.getState();
		if (state != STATES.IDLE) {
			return;
		}

		events.dispatch(ACTION_EVENTS.ACTION_INFO_TOGGLE);
	}

	keydownM() {
		if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_SOUND_TOGGLE)) return;
		this.audio.toggle();
	}

	keydownArrowUp() {
		let state = this.statesManager.getState();

		if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_BET_INC)) return;
		if (this.wallet.isBonus()) return;

		switch (state) {
			case STATES.IDLE:
				this.wallet.incCreditBet();
				break;
		}
	}

	keydownArrowDown() {
		let state = this.statesManager.getState();

		if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_BET_DEC)) return;
		if (this.wallet.isBonus()) return;

		switch (state) {
			case STATES.IDLE:
				this.wallet.decCreditBet();
				break;
		}
	}

	keydownPageUp() {
		let state = this.statesManager.getState();

		if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_COIN_INC)) return;
		if (this.wallet.isBonus()) return;

		switch (state) {
			case STATES.IDLE:
				this.wallet.incCoin();
				break;
		}
	}

	keydownPageDown() {
		let state = this.statesManager.getState();

		if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_COIN_DEC)) return;
		if (this.wallet.isBonus()) return;

		switch (state) {
			case STATES.IDLE:
				this.wallet.decCoin();
				break;
		}
	}

	keydownF() {
		if (!this.actions.isActionAllowed(ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST)) return;
		events.dispatch(ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST);
	}

	keydownBackspace(event) {
		this.preventDefault(event);
	}

	preventDefault(e) {
		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.stop();
		}
		e.returnValue = false;
		e.stopPropagation();
	}
}
